import PropTypes from 'prop-types';
import Button from 'components/UI/Button';

const ContractGenerationScreen = ({
  literals,
  message = '',
  isSubmitting = false,
  onGenerate,
}) => (
  <div className='full-screen-container digital-loan-preoffer'>
    <div className='screen-content digital-loan-preoffer__scroll'>
      <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
      <p className='digital-loan-phase2__body mb-4'>{literals.body}</p>
      {message && (
        <p className='digital-loan-phase2__body' role='alert'>
          {message}
        </p>
      )}
    </div>
    <div className='screen-actions'>
      <Button
        text={literals.generate}
        loading={isSubmitting}
        disabled={isSubmitting}
        onClick={onGenerate}
      />
    </div>
  </div>
);

ContractGenerationScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  message: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onGenerate: PropTypes.func.isRequired,
};

export default ContractGenerationScreen;
